import { ref } from 'vue'
import { useCookie } from 'nuxt/app';
import { ampli } from '../ampli';
import { Cookies } from '../constants/cookies';
import { getCampaignCookie } from './getCampaignCookie'

declare global {
  interface Window {
    CookieInformation: any;
  }
}

export function useSingleSignUpParameters(locale: string) {

  const { public: { domain } } = useRuntimeConfig();

  const refineCampaignQuery = () => {
    const campaignCookieString = getCampaignCookie(document);
    return campaignCookieString && campaignCookieString.length ? `&${campaignCookieString.join('&')}` : '';
  }

  const campaign = ref<string>(refineCampaignQuery());

  const refineFbCookie = (value:string | null | undefined, key: string) => {
    return value ? `&${key}=${value}` : '';
  };

  const refineAmpDeviceId = (): string => {
    if (import.meta.server) {
      return '';
    }
    if (!ampli.isLoaded) {
      return '';
    }
    const deviceId = (ampli.client as { getDeviceId?: () => string | undefined }).getDeviceId?.();
    if (deviceId == null || String(deviceId).trim() === '') {
      return '';
    }
    return `&amp_device_id=${encodeURIComponent(String(deviceId))}`;
  };

  // _fbp param
  const fbpName = Cookies.FACEBOOK_PIXEL;
  const fbpCookieValue = useCookie(fbpName);
  let fbp = ref<string>(refineFbCookie(fbpCookieValue.value, 'facebook_browser_id'|| '') || '');

  // _fbc param
  const fbcName = Cookies.FACEBOOK_CLICK_ID;  
  const fbcCookieValue = useCookie(fbcName);
  
  let fbc = ref<string>(refineFbCookie(fbcCookieValue.value, 'facebook_click_id'|| '') || '');
  
  // cookie consent param
  let consent = ref(`cookie_consent=${window?.CookieInformation?.getConsentGivenFor('cookie_cat_marketing') || false}`);

  // locale consent param
  let locales = `locale=${locale}`;
  
  return `?${consent.value}&${locales}${campaign.value}${fbc.value}${fbc.value}${refineAmpDeviceId()}&referring_domain=${domain}`;
}
